var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministradores(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.661,
    height: 18.577,
    viewBox: "0 0 16.661 18.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "df7694c2aaaf6b95c8c66453452cafd7",
    transform: "translate(-60.6 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    "data-name": "Caminho 555",
    d: "M68.641,27.652l-.919-1.594a1.16,1.16,0,0,1,.425-1.585l.2-.118a3.876,3.876,0,0,1,0-.766l-.2-.116a1.163,1.163,0,0,1-.425-1.587l.919-1.594a1.168,1.168,0,0,1,.705-.54,1.16,1.16,0,0,1,.881.116l.2.118a4.812,4.812,0,0,1,.66-.375v-.243c0-.019.011-.036.011-.055a5.6,5.6,0,0,0-2.377-1.02v-.574a4.061,4.061,0,1,0-3.482,0V18.3c-4.627.887-4.644,5.368-4.644,7.96,0,2.023,8.847,1.966,8.748,1.939A1.158,1.158,0,0,1,68.641,27.652Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    "data-name": "Caminho 556",
    d: "M478.428,508.9a3.633,3.633,0,0,0-.148-.978l.912-.525-.921-1.594-.9.519a3.673,3.673,0,0,0-1.7-.974V504.3h-1.841v1.05a3.666,3.666,0,0,0-1.7.974l-.9-.519L470.3,507.4l.912.525a3.71,3.71,0,0,0-.148.978,3.634,3.634,0,0,0,.148.978l-.912.527.921,1.594.9-.519a3.678,3.678,0,0,0,1.706.974v1.05l1.841,0v-1.048a3.671,3.671,0,0,0,1.706-.974l.9.519.919-1.594-.91-.525A3.709,3.709,0,0,0,478.428,508.9Zm-3.681,2.224a2.222,2.222,0,1,1,2.222-2.222A2.22,2.22,0,0,1,474.747,511.126Z",
    transform: "translate(-401.934 -484.93)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministradores);
export default __webpack_public_path__ + "static/media/Administradores.11bd39619aa51e8b00c7f70c68c07396.svg";
export { ForwardRef as ReactComponent };